import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { GradesAdapter } from './dto/grades.adapter';
import { GradesController } from './grades.controller';
import { Grades } from './grades.entity';
import { GradesService } from './grades.service';

@Module({
  imports: [
    
    TypeOrmModule.forFeature([Grades]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [GradesController],
  providers: [GradesService, GradesAdapter,ApplicationExceptionHandler,LogsService],
  exports: [GradesService],
})
export class GradesModule {}
